import { cloneDeep, isFunction } from 'lodash/lang';

import { normalizePhoneNumber } from '../../../../../../../services/geo/e-164';
import { PAYMENT_TYPE_PHYSICAL, PHYSICAL_NOT_ASSIGNED } from '../../../constants';

export function parsePatientInfo(
  {
    firstName,
    lastName,
    middleName,
    preferredName,
    dob,
    medicalRecordNumber,
    phonesInfo,
    email,
    address,
    ssn,
    cardInfo,
    guardian,
    sex,
    pronouns,
    isDeceased,
    primaryLanguage,
    isInterestedInFutureResearch,
    isSmsOptIn,
    heightFt,
    heightIn,
    weight,
    races,
    ethnicities,
    interestedInFutureResearch,
    smsOptIn,
    source,
    digitalPaymentAllowed,
    ssnOptional,
    cardAssignmentStatus
  },
  defaultPhoneCountryId
) {
  return {
    firstName,
    lastName,
    middleName,
    preferredName,
    dob,
    medicalRecordNumber: medicalRecordNumber || '',
    phonesInfo: {
      primary: parsePhoneNumber(
        phonesInfo?.primaryPhoneCode || defaultPhoneCountryId,
        phonesInfo?.primary,
        phonesInfo?.primaryPhoneType
      ),
      alternative: parsePhoneNumber(
        phonesInfo?.alternativePhoneCode || defaultPhoneCountryId,
        phonesInfo?.alternative,
        phonesInfo?.alternativePhoneType
      ),
      preferredContactMethod: phonesInfo.preferredContactMethod,
      neverCallAgain: phonesInfo.neverCallAgain,
      voicemailNotAllowed: phonesInfo.voicemailNotAllowed
    },
    email,
    address: {
      addressLine1: address.addressLine1,
      addressLine2: address.addressLine2,
      city: address.city,
      country: address.country,
      state: address.state,
      zipCode: address.zipCode || ''
    },
    ssn,
    cardId: cardInfo?.id,
    paymentType: resolveCardTypeBasedOnCardAssignmentStatusAndCardType(cardInfo?.paymentType, cardAssignmentStatus),
    guardianFirstName: guardian?.firstName,
    guardianLastName: guardian?.lastName,
    guardianEmail: guardian?.email,
    guardianPhone: parsePhoneNumber(guardian?.phoneCode || defaultPhoneCountryId, guardian?.phone),
    guardianDob: guardian?.dob,
    sex,
    pronouns,
    isDeceased,
    primaryLanguage,
    isInterestedInFutureResearch,
    isSmsOptIn,
    heightFt,
    heightIn,
    weight,
    races,
    ethnicities,
    interestedInFutureResearch,
    smsOptIn,
    source,
    digitalPaymentAllowed,
    ssnOptional,
    cardAssignmentStatus
  };
}

export function resolveCardTypeBasedOnCardAssignmentStatusAndCardType(paymentType, cardAssignmentStatus) {
  if (paymentType) {
    return paymentType;
  } else if (cardAssignmentStatus && cardAssignmentStatus === PHYSICAL_NOT_ASSIGNED) {
    return PAYMENT_TYPE_PHYSICAL;
  } else {
    return null;
  }
}

export function convertDobToDate(dob) {
  // Default to original value if original conditional returns false.
  // This can occur if info.dob has already been converted to a formatted string
  // and the user submits and add patient form more than once due to previous errors
  // and corrections within the form. Would prefer this to be a pure function, but this
  // default value should alleviate the problem.
  return (dob && isFunction(dob.format) && dob.format('DD/MMM/YYYY')) || dob;
}

export function preparePatientInfoForAssign(info, currentStudy) {
  const patientInfo = cloneDeep(info);

  const studyIdentifier = currentStudy.studyId;
  const studySiteIdentifier = currentStudy.ssuId;
  const patientSourceId = currentStudy.patientSourceId;
  const statusName = 'Identified';
  const email = patientInfo.email || '';

  const patient = {
    ...patientInfo,
    patientUniqueIdentifier: info.uniqueIdentifier,
    studyIdentifier,
    studySiteIdentifier,
    patientSourceId,
    statusName,
    email,
    statusChangeLocation: 'PATIENT_INFO'
  };

  delete patient.patientId;

  return patient;
}

function parsePhoneNumber(_countryId, _nationalNumber, _phoneType) {
  const countryId = _countryId || null;
  const nationalNumber = _nationalNumber || '';
  const phoneType = _phoneType || null;
  return {
    countryId,
    nationalNumber: normalizePhoneNumber(nationalNumber, countryId),
    phoneType
  };
}
